import { render, staticRenderFns } from "./logisticsList.vue?vue&type=template&id=a83ad524&scoped=true"
import script from "./logisticsList.vue?vue&type=script&lang=js"
export * from "./logisticsList.vue?vue&type=script&lang=js"
import style0 from "./logisticsList.vue?vue&type=style&index=0&id=a83ad524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83ad524",
  null
  
)

export default component.exports